/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';

interface Props {
  originalTitle: string | JSX.Element;
  proposedTitle: string | JSX.Element;
  originalTypeCount?: number;
  originalFieldCount?: number;
  proposedTypeCount?: number;
  proposedFieldCount?: number;
}

export const TypesAndFieldsDelta = ({
  originalTitle,
  proposedTitle,
  originalTypeCount,
  originalFieldCount,
  proposedTypeCount,
  proposedFieldCount,
}: Props) => (
  <div className="flex h-24 text-base text-black">
    <div
      className="flex w-56 flex-col justify-center pl-4"
      css={css`
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 226 103' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='1 1  190 1  225 48  190 102  1 102' strokeLinejoin='round' fill='rgb(252, 253, 255)' stroke='rgb(235, 238, 240)' /%3E%3C/svg%3E");

        background-repeat: no-repeat;
      `}
    >
      <div>{originalTitle}</div>
      <div className="mt-1 flex">
        <Count
          label="types"
          count={originalTypeCount}
          className={classnames('mr-8', {
            'mr-4': originalTypeCount && originalTypeCount > 9999,
          })}
        />
        <Count label="fields" count={originalFieldCount} />
      </div>
    </div>
    <div className="flex min-w-52 flex-col justify-center pl-4">
      <div>{proposedTitle}</div>
      <div className="mt-1 flex">
        <Count
          label="types"
          count={proposedTypeCount}
          className={classnames('mr-8', {
            'mr-4': proposedTypeCount && proposedTypeCount > 9999,
          })}
        />
        <Count label="fields" count={proposedFieldCount} />
      </div>
    </div>
  </div>
);

const Count = ({
  label,
  count,
  className,
}: {
  label: 'fields' | 'types';
  count?: number;
  className?: string;
}) => (
  <div className={classnames('flex flex-col', className)}>
    <div className="text-xs uppercase text-secondary">{label}</div>
    <div className="text-xl">{count ?? '--'}</div>
  </div>
);
